export const MANAGER = "manager" // login role number 0 and is_manager = 1
export const EMPLOYER = "employer" // login role number 1
export const EMPLOYEE = "employee" // login role number 0 and is_manager = 0

export const generateApiEndpointByRole = (baseEndpoint, userRole) => {
    if(userRole == null) return `/${baseEndpoint}`
    const roleEndpoint = userRole === 0 ? 'employee' : 'employer';
    return `/${roleEndpoint}/${baseEndpoint}`;
  };